<template>
<div>
    <div class="relative w-full quoteboost-one p-4 pr-16 text-white" v-if="show && variant === 'dark'">
        <div class="rocket absolute z-0 pointer-events-none">
            <svg width="52" height="137" viewBox="0 0 52 137" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="52" height="137">
            <rect width="52" height="137" rx="10" fill="url(#paint0_linear)"/>
            </mask>
            <g mask="url(#mask0)">
            <path d="M22.3722 58C22.3722 58 22.406 66.0452 20.6015 95.9395C19.6541 111.649 15.9549 131.748 11.9173 142.348C8.27443 151.931 4 156.321 4 156.321L17.7256 168.601L38.218 171L55 161.303C55 161.303 48.6165 155.531 44.3872 146.54C38.5338 134.105 34.203 115.53 33.1992 97.5909C31.4398 66.6521 31.4511 58 31.4511 58H22.3722Z" fill="url(#paint1_linear)" fill-opacity="0.14"/>
            <path d="M19.2092 47.3297C18.4505 47.3297 14.9465 49.9535 14.2034 52.163C13.4604 54.3724 14.9777 61.407 15.5487 61.407C15.9554 61.407 16.3543 60.1804 16.5421 59.49C16.7923 58.5639 17.4728 57.8085 18.3567 57.5485C18.5991 57.4754 18.8572 57.4348 19.1153 57.4348H20.5545L19.2092 47.3297Z" fill="#FF6961"/>
            <path d="M19.4908 49.4255C19.2561 49.5067 18.1064 49.9048 17.1913 50.579C16.0415 51.4157 15.361 52.033 14.9621 53.0159C14.5632 54.0069 15.0638 59.1894 15.4392 60.0261C15.8147 60.8709 16.4247 59.8961 16.4247 59.8961C16.3935 60.0017 16.3543 60.1073 16.3231 60.2129C16.3152 60.2373 16.3074 60.2617 16.2996 60.286C16.2996 60.2942 16.2918 60.3104 16.284 60.3185C16.2761 60.351 16.2605 60.3835 16.2448 60.416C16.2448 60.4241 16.2448 60.4241 16.237 60.4323C16.2214 60.4729 16.2057 60.5054 16.1901 60.546C16.1745 60.5866 16.1588 60.6272 16.1353 60.6678C16.1275 60.6922 16.1119 60.7247 16.0962 60.7491C16.0884 60.7653 16.0806 60.7815 16.0728 60.7978C16.0571 60.8303 16.0415 60.8628 16.018 60.9034C15.9867 60.9603 15.9633 61.009 15.932 61.0577C15.8851 61.1308 15.8459 61.1958 15.799 61.2446C15.7599 61.2852 15.7286 61.3177 15.6895 61.342C15.6817 61.3502 15.6739 61.3583 15.6582 61.3583C15.6426 61.3664 15.6269 61.3745 15.6035 61.3827C15.5957 61.3827 15.5878 61.3908 15.5878 61.3908C15.58 61.3908 15.5722 61.3908 15.5644 61.3989C15.5566 61.3989 15.5487 61.3989 15.5409 61.3989C14.9699 61.3989 13.4526 54.3643 14.1956 52.1549C14.9386 49.9454 18.4427 47.3135 19.2014 47.3216L19.4908 49.4255Z" fill="#FFAD97"/>
            <path d="M20.5623 57.4348H19.1232C18.8572 57.4348 18.6069 57.4755 18.3645 57.5486C18.2237 57.5892 18.0985 57.646 17.9656 57.7029C17.9969 57.6785 19.3031 56.8094 19.4908 55.396C19.6785 53.9744 19.6237 50.4247 19.6237 50.4247L20.5623 57.4348Z" fill="#E5543C"/>
            <path d="M35.7909 47.3297C36.5496 47.3297 40.0536 49.9535 40.7967 52.163C41.5397 54.3724 40.0223 61.407 39.4514 61.407C39.0446 61.407 38.6457 60.1804 38.458 59.49C38.2077 58.5639 37.5272 57.8085 36.6434 57.5485C36.4009 57.4754 36.1428 57.4348 35.8847 57.4348H34.4456L35.7909 47.3297Z" fill="#E5543C"/>
            <path d="M34.4377 57.4348H35.8769C36.135 57.4348 36.3931 57.4755 36.6356 57.5486C36.7764 57.5892 36.9015 57.646 37.0345 57.7029C37.0032 57.6785 35.697 56.8094 35.5093 55.396C35.3216 53.9744 35.3763 50.4247 35.3763 50.4247L34.4377 57.4348Z" fill="#C13623"/>
            <path d="M35.5093 49.4255C35.7439 49.5067 36.8937 49.9048 37.8088 50.579C38.9586 51.4157 39.6391 52.033 40.038 53.0159C40.4369 54.0069 39.9363 59.1894 39.5608 60.0261C39.1854 60.8709 38.5753 59.8961 38.5753 59.8961C38.6066 60.0017 38.6457 60.1073 38.677 60.2129C38.6848 60.2373 38.6926 60.2617 38.7005 60.286C38.7005 60.2942 38.7083 60.3104 38.7161 60.3185C38.7239 60.351 38.7396 60.3835 38.7552 60.416C38.7552 60.4241 38.7552 60.4241 38.763 60.4323C38.7787 60.4729 38.7943 60.5054 38.81 60.546C38.8256 60.5866 38.8413 60.6272 38.8647 60.6678C38.8725 60.6922 38.8882 60.7247 38.9038 60.7491C38.9117 60.7653 38.9195 60.7815 38.9273 60.7978C38.9429 60.8303 38.9586 60.8628 38.982 60.9034C39.0133 60.9603 39.0368 61.009 39.0681 61.0577C39.115 61.1308 39.1541 61.1958 39.2011 61.2446C39.2402 61.2852 39.2714 61.3177 39.3106 61.342C39.3184 61.3502 39.3262 61.3583 39.3418 61.3583C39.3575 61.3664 39.3731 61.3745 39.3966 61.3827C39.4044 61.3827 39.4122 61.3908 39.4122 61.3908C39.4201 61.3908 39.4279 61.3908 39.4357 61.3989C39.4435 61.3989 39.4513 61.3989 39.4592 61.3989C40.0301 61.3989 41.5475 54.3643 40.8045 52.1549C40.0614 49.9454 36.5574 47.3135 35.7987 47.3216L35.5093 49.4255Z" fill="#C13623"/>
            <path d="M35.032 24.0897C32.4431 18.8666 29.377 15 27.4998 15C25.6227 15 22.275 19.2321 19.9677 24.0897C17.6603 28.9554 17.5665 33.0169 17.9106 37.639L20.5621 57.4267H34.4376L37.0891 37.639C37.4332 33.0169 37.6131 29.3209 35.032 24.0897Z" fill="white"/>
            <path d="M32.1539 19.1346H29.2756C30.9103 21.7503 33.4053 27.2496 33.6869 32.1315C33.9763 37.0135 32.2243 55.0304 29.3303 55.0304C26.4363 55.0304 22.3613 55.0304 22.3613 55.0304C21.2428 55.0304 19.2014 47.3379 19.2014 47.3379L20.5545 57.4349L20.6015 57.7842C20.711 58.5883 21.368 59.1813 22.1501 59.1813H32.8344C33.6165 59.1813 34.2735 58.5802 34.383 57.7842L34.43 57.4349L37.0815 37.6471C37.4256 33.0251 37.6055 29.3291 35.0244 24.0978C34.1093 22.2295 33.1238 20.5399 32.1539 19.1346Z" fill="#EAE6DF"/>
            <path d="M28.5482 40.1246C32.1983 40.1246 35.1574 37.2333 35.1574 33.6668C35.1574 30.1002 32.1983 27.209 28.5482 27.209C24.898 27.209 21.939 30.1002 21.939 33.6668C21.939 37.2333 24.898 40.1246 28.5482 40.1246Z" fill="#EAE6DF"/>
            <path d="M30.1515 49.1006C30.1515 49.1006 30.5973 52.6504 31.3482 53.6739C32.0912 54.6974 27.5234 55.5503 27.5234 55.5503L30.1515 49.1006Z" fill="#EAE6DF"/>
            <path d="M32.1539 19.1346H22.8384C24.5513 16.6733 26.319 15 27.5 15C28.7045 15 30.4096 16.6002 32.1539 19.1346Z" fill="#FF6961"/>
            <path d="M20.6092 57.776C20.7187 58.5802 21.3757 59.1732 22.1579 59.1732H32.8421C33.6242 59.1732 34.2813 58.5721 34.3908 57.776L34.4377 57.4267H20.5623L20.6092 57.776Z" fill="#C13623"/>
            <path d="M30.1515 49.1006C30.0264 48.2558 28.4308 46.6555 27.5235 46.6555C26.6162 46.6555 25.0206 48.2476 24.8954 49.1006C24.7703 49.9454 26.71 62 27.5235 62C28.3369 62 30.2767 49.9454 30.1515 49.1006Z" fill="#FF6961"/>
            <path d="M27.5236 39.4586C30.9577 39.4586 33.7417 36.5673 33.7417 33.0007C33.7417 29.4342 30.9577 26.5429 27.5236 26.5429C24.0894 26.5429 21.3054 29.4342 21.3054 33.0007C21.3054 36.5673 24.0894 39.4586 27.5236 39.4586Z" fill="#FF6961"/>
            <path d="M31.8062 35.7506C33.2687 33.2928 32.5357 30.0691 30.1692 28.5503C27.8026 27.0315 24.6986 27.7927 23.2361 30.2505C21.7737 32.7082 22.5066 35.9319 24.8732 37.4508C27.2397 38.9696 30.3438 38.2084 31.8062 35.7506Z" fill="#E5543C"/>
            <path d="M33.7416 33.0007C33.7416 36.5667 30.9571 39.4585 27.5234 39.4585C25.3099 39.4585 23.3702 38.2644 22.2673 36.453C24.6764 38.037 27.8989 37.7445 29.995 35.5594C32.0912 33.3825 32.3806 30.0277 30.8554 27.5339C32.5918 28.6873 33.7416 30.71 33.7416 33.0007Z" fill="#E5543C"/>
            <path d="M27.5236 37.7121C30.029 37.7121 32.0601 35.6027 32.0601 33.0007C32.0601 30.3987 30.029 28.2893 27.5236 28.2893C25.0181 28.2893 22.9871 30.3987 22.9871 33.0007C22.9871 35.6027 25.0181 37.7121 27.5236 37.7121Z" fill="#14125A"/>
            <path d="M27.0151 36.0468C28.9719 36.0468 30.5582 34.3994 30.5582 32.3671C30.5582 30.3348 28.9719 28.6873 27.0151 28.6873C25.0583 28.6873 23.4719 30.3348 23.4719 32.3671C23.4719 34.3994 25.0583 36.0468 27.0151 36.0468Z" fill="url(#paint2_linear)"/>
            <path d="M26.5776 31.9267C27.2863 31.1907 27.4299 30.1467 26.8984 29.5947C26.3669 29.0427 25.3616 29.1919 24.653 29.9278C23.9443 30.6638 23.8007 31.7079 24.3322 32.2598C24.8637 32.8118 25.869 32.6626 26.5776 31.9267Z" fill="#D8E6EF"/>
            <path d="M27.4999 15C26.4831 15 25.0361 16.2428 23.55 18.1599C23.55 18.1599 25.4272 16.7383 27.1793 17.2338C27.6642 17.3719 28.6419 18.1193 29.2754 19.1265H32.1538C30.4096 16.6002 28.7045 15 27.4999 15Z" fill="#E5543C"/>
            <path d="M27.5234 62C27.3435 62 27.1167 61.4314 26.8664 60.5297C26.8899 60.546 27.4452 61.0658 27.7737 60.2698C28.1022 59.4737 28.5324 50.6196 28.2508 49.3361C27.9692 48.0527 25.8574 47.6222 25.8574 47.6222L26.5614 47.0373C26.9055 46.8099 27.2497 46.6555 27.5234 46.6555C28.4307 46.6555 30.0263 48.2476 30.1514 49.1006C30.2766 49.9454 28.3369 62 27.5234 62Z" fill="#E5543C"/>
            </g>
            <defs>
            <linearGradient id="paint0_linear" x1="0" y1="0" x2="61.413" y2="4.47258" gradientUnits="userSpaceOnUse">
            <stop stop-color="#005BAF"/>
            <stop offset="1" stop-color="#17043F"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="30" y1="99" x2="30" y2="148" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="23.4745" y1="32.3642" x2="30.5534" y2="32.3642" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3551A7"/>
            <stop offset="1" stop-color="#232F7A"/>
            </linearGradient>
            </defs>
            </svg>
        </div>
        <div class="clouds absolute z-0 pointer-events-none">
            <svg width="201" height="51" viewBox="0 0 201 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="maskclouds" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="51">
                    <rect width="201" height="51" fill="url(#clouds_linear)" />
                </mask>
                <g mask="url(#maskclouds)">
                    <path d="M296 76.4511V110H-9V3C13.2158 3 32.0668 11.3529 38.7768 22.9397C40.469 22.6654 42.2597 22.5169 44.0897 22.5169C54.7352 22.5169 63.4326 27.3961 63.8852 33.5208C65.1052 33.4294 66.3252 33.3837 67.5845 33.3837C73.9207 33.3837 79.7845 34.5035 84.6645 36.4118C86.8487 32.1382 93.6571 29.0187 101.725 29.0187C104.263 29.0187 106.664 29.3272 108.848 29.8757C115.656 23.671 127.581 19.5573 141.198 19.5573C162.371 19.5573 179.529 29.5215 179.529 41.8166C179.529 42.2737 179.49 42.7194 179.451 43.165C187.558 43.6106 194.405 46.5816 197.652 50.7066C200.309 50.0439 203.241 49.6782 206.31 49.6782C218.471 49.6782 228.329 55.403 228.329 62.4762C228.329 62.5447 228.329 62.6247 228.31 62.6933C235.708 63.3332 241.907 66.1099 244.996 69.9036C250.191 67.5154 256.763 66.087 263.906 66.087C276.775 66.087 287.775 70.7149 292.261 77.2624C293.442 76.9424 294.701 76.6568 296 76.4511Z" fill="white" fill-opacity="0.1" />
                </g>
                <defs>
                    <linearGradient id="clouds_linear" x1="0" y1="0" x2="151.824" y2="114.81" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#005BAF" />
                        <stop offset="1" stop-color="#17043F" />
                    </linearGradient>
                </defs>
            </svg>
        </div>

        <div class="flex w-full font-bold text-lg text-green mb-2">
            <div>Quoteboost</div>
        </div>

        <div class="flex w-full mb-2">
            <div>We will <b class="text-green">boost</b> your chances of finding a loan by also searching for quotes of {{ newAmountTermCombo.amount | currency}}.</div>
        </div>

        <div class="flex w-full text-xs mb-2 items-center">
            <div class="pr-2">
                <input type="checkbox" class="checkbox-circle m-0" style="margin-top: 0;" v-model="accepted" @click="quoteToggle" />
            </div>
            <div class="">
                Untick this box if you don’t want us to do this. 
            </div>
        </div>
    </div>

    <div class="w-full flex flex-wrap" v-if="show && variant === 'light'">
        <div class="flex w-full font-bold text-lg text-green mb-2">
            <div>Quoteboost</div>
        </div>

        <div class="flex w-full mb-2">
            <div>We will <b class="text-green">boost</b> your chances of finding a loan by also searching for quotes of {{ newAmountTermCombo.amount | currency}}.</div>
        </div>

        <div class="flex w-full text-xs mb-2 justify-between items-center">
            <div class="">
                Untick this box if you don’t want us to do this. 
            </div>
            <div class="pl-2">
                <input type="checkbox" class="checkbox-square m-0" style="margin-top: 0;" v-model="accepted" @click="quoteToggle"/>
            </div>
        </div>

    </div>

</div>
</template>

<script>
import { has } from "underscore";
export default {
    components: {
    },
    inject: ["$getValidationRules", "$getValidationMessages", '$globals', '$customer'],
    props: {
        form: {},
        name: {},
    },
    data() {
        return {
            accepted: true,
            variant: 'dark'
        };
    },
    computed: {
        enabled() {
            return this.variant !== null;
        },
        show() {
            return this.enabled && this.$customer.loanamount > 500 && this.newAmountTermCombo;
        },
        newAmountTermCombo() {
            if (this.$customer.loanamount && this.$customer.term) {
                let key = this.$customer.loanamount + ',' + this.$customer.term;
                if (has(this.$globals.quote_boost, key)) {
                    let result = this.$globals.quote_boost[key];
                    return result;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    },
    watch: {
        '$globals.quote_boost_variant': {
            deep: true,
            immediate: true,
            handler() {
                this.variant = this.$globals.quote_boost_variant;
                this.updateAllValues()
            }
        },
        accepted: {
            immediate: true,
            handler() {
                this.updateAllValues();
            }
        },
        '$customer.loanamount': {
            immediate: true,
            handler() {
                this.updateAllValues();
            }
        },
        '$customer.term': {
            immediate: true,
            handler() {
                this.updateAllValues();
            }
        },
    },
    methods: {
        updateAllValues() {
            if (this.enabled) {
                this.$set(this.$customer.extras, 'quoteboost_variant', this.show ? this.variant : 'hidden');
                this.$set(this.$customer.extras, 'quoteboost_accepted', this.accepted);
                if (this.accepted && this.newAmountTermCombo) {
                    this.$set(this.$customer.extras, 'alternative_amount', this.newAmountTermCombo.amount);
                    this.$set(this.$customer.extras, 'alternative_term', this.newAmountTermCombo.term);
                } else {
                    this.$delete(this.$customer.extras, 'alternative_amount');
                    this.$delete(this.$customer.extras, 'alternative_term');
                }
            } else {
                this.$delete(this.$customer.extras, 'alternative_amount');
                this.$delete(this.$customer.extras, 'alternative_term');
                this.$delete(this.$customer.extras, 'quoteboost_variant');
                this.$delete(this.$customer.extras, 'quoteboost_accepted');
            }
        },
        quoteToggle() {
            setTimeout(() => {
                window.amplitude.quoteBoostInteractionEvent(this.$customer.extras.quoteboost_accepted === true ? 'selected' : 'deselected');
            }, 500)
        }
    },
    mounted() {
    },
};
</script>

<style lang="scss">
.quoteboost-one {
    background: linear-gradient(100.86deg, #005BAF 0%, #17043F 99.61%);
    box-shadow: 0px 0px 20px rgba(27, 15, 176, 0.63);
    border-radius: 10px;
}
.rocket {
    bottom: 0;
    right: 10px;
    height: 137px;
    width: 52px;
}

.clouds {
    bottom: 0px;
    left: 0px;
    height: 51px;
    width: 201px;
}
</style>